import React from 'react';
import './CancelSection.css';
import CancelLink from '../CancelLink/CancelLink';
import { useLanguageContext } from '../../core/locale/LanguageContext';
import { useIframe } from '../../platform/iframe/useIframe';

interface cancelSectionProps {
  showCancelLink: boolean;
}

function CancelSection({ showCancelLink }: cancelSectionProps): React.ReactNode {
  const languageContext = useLanguageContext();
  const iframe = useIframe();

  if (iframe.isWidgetSdkEmbed()) {
    return null;
  }
  return (
    <div className="cancelSection">
      {showCancelLink && (
        <CancelLink aria-label={languageContext.getLocalizedText('inputCancelLabel')}>
          {languageContext.getLocalizedText('inputCancel')}
        </CancelLink>
      )}
    </div>
  );
}

export default CancelSection;
